import { useState } from "react";
import Link from "next/link";
import { stepItems } from "./utils";
import routes from "@/constants/routes";
import RightArrow from "@/public/icons/hiw-right-arrow.svg";
import Step3Image from "@/public/icons/hiw-step3.svg";
import TimeClock from "@/public/icons/clock-orange-circle.svg";
import ExpandableBox from "@/components/landing-old/ExpandableBox";

const Step3 = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };

  return (
    <section className="relative bg-white w-full px-4 md:px-5 lg:px-20 lg:py-16">
      <div className="h-20 lg:h-0"></div>
      <h2 className="text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">Step 3</h2>
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        <div className="flex flex-col lg:w-1/2">
          <h3 className="text-4xl lg:text-5xl font-bold text-landing-blue mb-5 md:mb-3 lg:mb-5">
            Get approved for Keyzy
          </h3>
          <div className="flex flex-col md:flex-row lg:flex-col items-center">
            <div className="w-full md:w-1/2 lg:w-full">
              <h4 className="font-serif text-xl lg:text-3xl text-landing-blue mb-5">
                Use our quick, easy and secure online portal
              </h4>
              <p className="font-base mb-5">
                Keyzy will do a detailed review of you and any other applicants with you. You will
                need to submit your ID, proof of income and bank statements through our secure
                portal.
              </p>
              <p className="font-base mb-5">
                Once we have all your information our team will review it and confirm once you have
                passed all our checks. You will then be able to arrange moving in!
              </p>
            </div>
            <div className="w-full md:w-1/2 lg:w-full hidden md:flex lg:hidden justify-around">
              <Step3Image width={"90%"} height={"100%"} />
            </div>
          </div>
          <div className="flex flex-row justify-between mb-0 md:mb-6 lg:mb-9">
            <a className="relative flex items-center" href={routes.register}>
              <span className={`relative text-base font-bold text-landing-orange`}>Apply now</span>
              <RightArrow className="md:ml-3 ml-1" />
            </a>
            <div className="flex flex-row justify-between items-center">
              <TimeClock className="mr-3" />
              <span className={`inline-block relative text-base text-landing-orange`}>
                2 - 3 days
              </span>
            </div>
          </div>
          <div className="md:hidden w-full my-5 flex justify-around">
            <Step3Image width={"80%"} height={"100%"} />
          </div>
          <div className="relative z-30 w-full">
            {stepItems.map((faq, idx) => (
              <div key={idx}>
                <ExpandableBox
                  question={faq.question}
                  answer={faq.answer}
                  active={activeIndex === idx}
                  clickHandler={() => clickHandler(idx)}
                  page={"hiw"}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="hidden lg:flex lg:justify-around items-center lg:w-1/2">
          <Step3Image width={"80%"} height={"100%"} />
        </div>
      </div>
    </section>
  );
};

export default Step3;
